import { useReveal } from "@/hooks/useReveal";

export const ContactSection = () => {
  const [ref, shown] = useReveal({ threshold: 0.2 });
  return (
    <section id="contact" data-testid="section-contact" className="seam-top bg-field">
      <div
        ref={ref}
        className={`mx-auto max-w-[900px] px-5 py-[120px] text-center transition-[opacity,transform] duration-[600ms] ease-out md:px-7 ${
          shown ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"
        }`}
      >
        <p className="eyebrow text-xs text-kraft">Contact</p>
        <h2 className="font-display mt-5 text-3xl font-extrabold leading-[1.08] text-warmwhite md:text-[40px]">
          Let’s talk fabric.
        </h2>
        <p className="mx-auto mt-5 max-w-md font-inter text-base leading-[1.65] text-warmwhite/75">
          The fastest way to reach us is by phone or WhatsApp.
        </p>
        <p className="mx-auto mt-4 max-w-md font-inter text-base leading-[1.65] text-warmwhite/75">
          We are a wholesale fabric supplier serving New York, Brooklyn, and the
          garment district, with our warehouse in Newark, New Jersey. By
          appointment, no walk-ins.
        </p>

        <div className="mt-14 flex flex-col items-center gap-10">
          {/* Phone */}
          <div>
            <p className="eyebrow text-[11px] text-warmwhite/60">Phone / WhatsApp</p>
            <a
              href="tel:+17187814444"
              data-testid="contact-phone-link"
              className="font-display mt-3 inline-block text-3xl font-extrabold text-warmwhite transition-colors duration-300 ease-out hover:text-kraft md:text-5xl"
            >
              +1 718 781 4444
            </a>
            <div className="mt-5">
              <a
                href="https://wa.me/17187814444"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-whatsapp-link"
                className="eyebrow inline-block border border-kraft px-6 py-3.5 text-[13px] text-warmwhite transition-colors duration-300 ease-out hover:bg-kraft hover:text-ink"
              >
                Message on WhatsApp
              </a>
            </div>
          </div>

          {/* Email */}
          <div>
            <p className="eyebrow text-[11px] text-warmwhite/60">Email</p>
            <a
              href="mailto:magnummoez@aol.com"
              data-testid="contact-email-link"
              className="font-display mt-3 inline-block break-all text-xl font-bold text-warmwhite transition-colors duration-300 ease-out hover:text-kraft md:text-3xl"
            >
              magnummoez@aol.com
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
